(() => {
  window.swinger.i18n()
    .then((i18n) => {
      window.swinger.observer.initialize('.swinger-button-watch[data-itemnumber]', (elem) => {
        const itemNumber = elem.getAttribute('data-itemnumber');
        const { 1: number } = `${itemNumber}`.split('-');
        const update = () => {
          let key = 'ui.video-player.play';
          const isClip = itemNumber.indexOf('AMA') === 0;
          const isScene = itemNumber.indexOf('-') > -1;
          const itemOwnState = window.swinger.user.getItemOwnState(itemNumber);
          const secondsInHour = 3600;
          const secondsInMinute = 60;
          let time;

          switch (true) {
            default:
              return;

            case itemOwnState.status === 'purchased' && isClip:
              key = 'ui.video-player.play.clip';
              break;

            case itemOwnState.status === 'purchased':
              key = `ui.video-player.play.${isScene ? 'scene' : 'movie'}`;
              break;

            case itemOwnState.status === 'rented' && !!itemOwnState.rentalEndTimestamp: {
              const remainingSeconds = itemOwnState.rentalEndTimestamp - Math.ceil((new Date()).getTime() / 1000);
              const hours = Math.floor(remainingSeconds / secondsInHour);
              const minutes = Math.floor((remainingSeconds % secondsInHour) / secondsInMinute);
              time = i18n(hours > 0 ? 'ui.duration.full' : 'ui.duration.minutes', {
                hours,
                minutes,
              });
              key = `ui.video-player.play.${isScene ? 'scene' : 'movie'}.remainingRentPeriod`;
            }
              break;

            case itemOwnState.status === 'rented':
              key = `ui.video-player.play.${isScene ? 'scene' : 'movie'}.startRentPeriod`;
              break;
          }

          const text = i18n(key, {
            time,
            number: number || '',
          });

          elem.setAttribute('aria-label', text);
          elem.childNodes[1].textContent = text;
        };

        document.addEventListener('swinger.user:authchange', update);

        update();
      }, false);
    })
    .catch(console.info);
})();
